import useMediaQuery from '@mui/material/useMediaQuery'
import {
    defineBlock,
    smartProps,
    useInspectorControl,
    BlockWrapper,
} from '@smartfire/js-block-engine'
import React from 'react'
import style from './block.module.scss'

const Inspector = React.lazy(() => import('./Inspector'))

const Spacer = ({ height, laptopHeight, tabletHeight, mobileHeight }) => {
    useInspectorControl(Inspector)

    const isLaptop = useMediaQuery(`(max-width: ${style.laptopBreakpoint})`)
    const isTablet = useMediaQuery(`(max-width: ${style.tabletBreakpoint})`)
    const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`)

    const spacerHeight = () => {
        if (isMobile) {
            return mobileHeight
        } else if (isTablet) {
            return tabletHeight
        } else if (isLaptop) {
            return laptopHeight
        }
        return height
    }

    return (
        <BlockWrapper.Div
            className={style.block}
            style={{ height: spacerHeight() }}
        ></BlockWrapper.Div>
    )
}

export default defineBlock({
    Block: Spacer,
    smartProps: {
        height: smartProps.number.withDefault(50),
        laptopHeight: smartProps.number.withDefault(45),
        tabletHeight: smartProps.number.withDefault(40),
        mobileHeight: smartProps.number.withDefault(30),
    },
    setup: {
        title: 'Spacer',
    },
})
